import { Box, Table, TableRow, TopBar } from '@sam/components';
import { TableHeader, TableKey } from '@sam/components/src/Table/Table.types';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { updateSchambeckUserTableConfig, useData } from 'shared';
import { Right } from 'shared/src/userRole/UserRole.types';
import { NotAllowed } from '../../components/NotAllowed';
import { useUser } from '../../components/UserContext';
import { convertOfficesIntoTableEntries } from '../../utils/office/Office.utils';
import { isUserAllowedToDo } from '../../utils/user/User.utils';
import { IconComponent, IconType } from '../../components/icons/IconComponent';

const OfficeOverview: React.FC = () => {
  const { user, axios, updateContextUser } = useUser();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: offices } = useData('OFFICES_ALL', {
    config: { fallbackData: [] },
  });
  const [filterValue, setFilterValue] = useState<string>('');
  //Holds tableRows for offices
  const rows: TableRow[] = useMemo(
    () => convertOfficesIntoTableEntries(user.right, offices, navigate),
    [user.right, offices, navigate],
  );

  return isUserAllowedToDo(user.right, Right.OFFICE_OVERVIEW) ? (
    <>
      <TopBar title={t('pages.office.overview.headline')} onSearch={setFilterValue}>
        {isUserAllowedToDo(user.right, Right.OFFICE_CREATE) && (
          <IconComponent type={IconType.ADD} onClick={() => navigate('/office/edit')} width={40} />
        )}
      </TopBar>
      <Box>
        <Table
          tableConfig={user.tableConfig?.get(TableKey.OFFICE_OVERVIEW)}
          updateTableConfig={(updatedHeader) => {
            updateSchambeckUserTableConfig(
              axios,
              user,
              TableKey.OFFICE_OVERVIEW,
              updatedHeader,
            ).then((updatedUser) => updatedUser && updateContextUser(updatedUser));
          }}
          filterValue={filterValue}
          rows={rows}
          header={
            t('pages.office.overview.tableHeader', {
              returnObjects: true,
            }) as TableHeader[]
          }
        />
      </Box>
    </>
  ) : (
    <NotAllowed neccessaryRight={Right.OFFICE_OVERVIEW} />
  );
};
export default OfficeOverview;
